<template>
  <div v-if="npsDatas.nps_overall" id="feedback">
    <div v-if="isLoading" class="loading">&nbsp;</div>
    <div v-if="npsDatas.nps_overall.four_weeks_count > 1" class="dashboard">
      <DashboardTitleSearch
        :property-name="npsDatas.nps_overall.property_name"
        :property-id="property_id"
      />
    </div>
    <div v-if="feedbacks.data" class="feedback-list">
      <h2 class="bold">FEEDBACK</h2>
      <span v-if="!feedbacks.data.length">No Feedback!</span>
      <div class="search-filter">
        <div class="sentiment-filter">
          <div>Sentiment Filter:</div>
          <img src="../assets/mad.png" @click="sentimentFilter(1)" />
          <img src="../assets/neutral.png" @click="sentimentFilter(5)" />
          <img src="../assets/happy.png" @click="sentimentFilter(10)" />
        </div>
        <div
          v-if="Math.ceil(feedbacks.total_items / per_page) >= page"
          class="pagination"
        >
          <button
            v-if="page > 1"
            class="button button-100 page-back"
            @click="pageBack"
          >
            Back
          </button>
          &nbsp;
          <div class="pagination-page">
            Page {{ page }} of {{ Math.ceil(feedbacks.total_items / per_page) }}
          </div>
          <button
            v-if="page < Math.ceil(feedbacks.total_items / per_page)"
            class="button button-100 page-next"
            @click="pageNext"
          >
            Next
          </button>
        </div>
      </div>
      <div class="clearfix" />

      <div>
        <div
          v-for="(feedback, i) in feedbacks.data"
          :key="i"
          class="feedback-item"
        >
          <FeedbackItem :feedback="feedback" />
        </div>
      </div>

      <v-dialog />
    </div>
    <div
      v-if="Math.ceil(feedbacks.total_items / per_page) >= page"
      class="pagination"
    >
      <button
        v-if="page > 1"
        class="button button-100 page-back"
        @click="pageBack"
      >
        Back
      </button>
      &nbsp;
      <div class="pagination-page">
        Page {{ page }} of {{ Math.ceil(feedbacks.total_items / per_page) }}
      </div>
      <button
        v-if="page < Math.ceil(feedbacks.total_items / per_page)"
        class="button button-100 page-next"
        @click="pageNext"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
import DashboardTitleSearch from "@/components/DashboardTitleSearch";
import FeedbackItem from "@/components/FeedbackItem";
import api from "@/api/index";
const apiService = new api.APIServiceFeedbackDashboard();
const apiServiceFeedback = new api.APIServiceFeedback();

export default {
  name: "DashboardFeedbackList",
  components: {
    DashboardTitleSearch,
    FeedbackItem
  },
  data() {
    return {
      feedbacks: [],
      isLoading: true,
      npsDatas: {},
      npsCategories: [],
      actions: [],
      page: 1,
      per_page: 25,
      total_items: 0,
      total_pages: 0,
      numberOfCategoriesToShow: 18,
      property_id: parseInt(this.$route.params.id),
      searchKeywords: "",
      sentimentScore: 0
    };
  },
  created() {
    this.isLoading = true;
    this.resetData();
    this.getPropertyFeedbackNPS();
    this.getPropertyFeedback();
  },
  methods: {
    getPropertyFeedback: function() {
      apiServiceFeedback
        .getFeedback(this.$route.params.id, this.page, this.sentimentScore)
        .then(data => {
          this.feedbacks = data;
          this.isLoading = false;
        });
    },
    getPropertyFeedbackNPS: function() {
      apiService.getPropertyFeedbackNPS(this.$route.params.id).then(data => {
        this.npsDatas = data;
        this.$store.commit("setProperty", {
          id: this.property_id,
          name: this.npsDatas.nps_overall.property_name
        });
      });
    },
    pageBack: function() {
      this.page = this.page - 1;
      this.getPropertyFeedback();
      window.scrollTo(0, 0);
    },
    pageNext: function() {
      this.page = this.page + 1;
      this.getPropertyFeedback();
      window.scrollTo(0, 0);
    },
    reloadFeedback: function() {
      this.getPropertyFeedback();
    },
    showAllCategories: function() {
      this.numberOfCategoriesToShow = this.npsCategories.length;
    },
    setNumberOfCategoriesToShow: function(number) {
      this.numberOfCategoriesToShow = number;
    },
    search: function() {
      let searchKeywords = this.searchKeywords
        .replace(/\s+/g, "+")
        .toLowerCase();
      this.$router.push({
        name: "dashboardFeedbackSearch",
        query: {
          propertyID: this.property_id,
          searchKeywords: searchKeywords,
          page: 1
        }
      });
    },
    deleteFeedback: function(feedbackID) {
      apiServiceFeedback.deleteFeedback(feedbackID).then(data => {});
      this.hide();
      setTimeout(() => {
        this.reloadFeedback();
      }, 2000);
    },
    deleteFeedbackIsSpam: function(feedbackID) {
      apiServiceFeedback.deleteFeedbackIsSpam(feedbackID).then(data => {});
      this.hide();
      setTimeout(() => {
        this.reloadFeedback();
      }, 2000);
    },
    deleteFeedbackAlert: function(feedbackID) {
      this.show(feedbackID);
    },
    deleteFeedbackIsSpamAlert: function(feedbackID) {
      this.showSpamDialog(feedbackID);
    },
    show: function(feedbackID) {
      this.$modal.show("dialog", {
        title: "Alert!",
        text: "Do you want to delete this Feedback?",
        buttons: [
          {
            title: "Yes",
            handler: () => {
              this.deleteFeedback(feedbackID);
            }
          },
          {
            title: "", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.
            handler: () => {} // Button click handler
          },
          {
            title: "No"
          }
        ]
      });
    },
    showSpamDialog: function(feedbackID) {
      this.$modal.show("dialog", {
        title: "Alert!",
        text: "Do you want to mark this feedback as Spammity Spam?",
        buttons: [
          {
            title: "Yes",
            handler: () => {
              this.deleteFeedbackIsSpam(feedbackID);
            }
          },
          {
            title: "", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.
            handler: () => {} // Button click handler
          },
          {
            title: "No"
          }
        ]
      });
    },
    hide: function() {
      this.$modal.hide("dialog");
    },
    sentiment: function(mcss) {
      if (mcss < -5) {
        return "Negative";
      } else if (mcss > -5 && mcss <= 20) {
        return "Neutral";
      } else {
        return "Positive";
      }
    },
    sentimentFilter: function(score) {
      this.sentimentScore = score;
      this.getPropertyFeedback();
    },
    resetData: function() {
      this.feedbacks = [];
      this.npsDatas = {};
      this.npsCategories = [];
      this.actions = [];
      this.page = 1;
      this.per_page = 25;
      this.total_items = 0;
      this.total_pages = 0;
      this.numberOfCategoriesToShow = 18;
      this.property_id = this.$route.params.id;
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 30px;
}
h2 {
  font-size: 18px;
}
#feedback {
  margin: 0 0;
}
.feedback-item {
  lost-column: 1/2;
}
.sentiment-filter div {
  padding-top: 5px;
  padding-right: 5px;
  float: left;
}
.sentiment-filter img {
  float: left;
  width: 30px;
}
.sentiment-icons {
  text-align: center;
}
.sentiment-icons img {
  width: 30px;
  padding-top: 5px;
}
.feedback-list {
  lost-utility: clearfix;
}
.italics {
  font-style: italic;
}
.pagination {
  float: right;
  margin-bottom: 10px;
}
.pagination-page {
  padding-top: 12px;
  padding-right: 5px;
  float: left;
}
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */
@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@media (max-width: 870px) {
  .feedback-item {
    lost-column: 1/1;
  }
}
@media (max-width: 499px) {
  h1 {
    font-size: 20px;
  }
}
</style>
